export function resolveConfigValue<T>(
  envVariableName: string,
  defaultValue: T,
  getEnvValue?: (key: string) => unknown
): T {
  if (typeof window !== 'undefined' && window.__APP_RUNTIME_CONFIG__) {
    const runtimeValue = window.__APP_RUNTIME_CONFIG__[envVariableName];
    if (runtimeValue !== undefined && runtimeValue !== '') {
      if (typeof defaultValue === 'number') {
        const numValue = Number(runtimeValue);
        return (isNaN(numValue) ? defaultValue : numValue) as T;
      }
      return runtimeValue as T;
    }
  }

  if (getEnvValue) {
    const envKey = `SWAPP_${envVariableName}`;
    const envValue = getEnvValue(envKey);
    if (envValue !== undefined && envValue !== '') {
      if (typeof defaultValue === 'number') {
        const numValue = Number(envValue);
        return (isNaN(numValue) ? defaultValue : numValue) as T;
      }
      return envValue as T;
    }
  }

  return defaultValue;
}

declare global {
  interface Window {
    __APP_RUNTIME_CONFIG__?: Record<string, string>;
  }
}
